require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./button"), require("./flyout"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./button", "./flyout"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./button"), require("./flyout")) : factory(root["./utils"], root["./button"], root["./flyout"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__25__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[12],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__12__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__25__;

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(251);


/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _ColorPicker = _interopRequireDefault(__webpack_require__(252));

exports.default = _ColorPicker.default;
exports.ColorPicker = _ColorPicker.default;

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _textColor_ = _interopRequireDefault(__webpack_require__(253));

var _utils = __webpack_require__(5);

var _flyout = __webpack_require__(25);

var _button = _interopRequireDefault(__webpack_require__(12));

var _ColorPicker = _interopRequireDefault(__webpack_require__(254));

var _StringResource = _interopRequireDefault(__webpack_require__(255));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const DEFAULT_OFFSET = 2;

const colorpickerClassName = _ColorPicker.default.colorpickerClassName.replace(/"/g, '');

const {
  sanitize
} = _utils.propsUtils;
const {
  uniqueId
} = _utils.lodash;
const {
  BOTTOM_RIGHT_START,
  BOTTOM_LEFT_START
} = _flyout.FlyoutPosition;

class ColorPicker extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_displayColor", (color, index) => /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      tabIndex: "0" // Make it keyboard focusable
      ,
      style: {
        background: color
      },
      className: `${colorpickerClassName}__cell`,
      onClick: () => this._handleSelect(color),
      onKeyDown: e => this._handleKey(e, color)
    }));
    this.state = {
      open: false
    };
    this._handleOpen = this._handleOpen.bind(this);
    this._handleSelect = this._handleSelect.bind(this);
    this._handleKey = this._handleKey.bind(this);
    this._id = uniqueId('ba-common-color-picker__');
    this.buttonRef = _react.default.createRef();
  }

  _handleOpen() {
    this.setState(state => ({
      open: !state.open
    }));
  }

  _handleSelect(color) {
    this.props.onColorSelected(color); // close the flyout after selection

    this.setState(state => ({
      open: !state.open
    }));
  }

  _handleKey(e, color) {
    // 13 = Return, 32 = Space
    if (e.keyCode === 13 || e.keyCode === 32) {
      this._handleSelect(color); // Prevent browser's default action: space does a PageDown


      e.preventDefault();
    }
  }

  render() {
    const {
      open
    } = this.state;
    const {
      selectedColor,
      disabled,
      title,
      className,
      style,
      buttonExtraOptions,
      flyoutExtraOptions,
      colorbarOffset,
      orientation,
      ...others
    } = this.props;
    const btnClassname = `${colorpickerClassName}__button ${'size' in buttonExtraOptions ? '' : 'size-default'}`;
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, sanitize(others, ColorPicker), {
      className: `${colorpickerClassName} ${className}`,
      ref: node => {
        this._colorPickerNode = node;
      },
      style: style
    }), /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
      "aria-controls": `${this._id}-flyout`,
      "data-tid": "ba-common-color-picker__button",
      hasIconOnly: true,
      kind: "ghost"
    }, sanitize(buttonExtraOptions, ColorPicker), {
      title: title,
      disabled: disabled,
      icon: _textColor_.default.id,
      ref: this.buttonRef,
      onClick: this._handleOpen,
      className: btnClassname
    }), !disabled && /*#__PURE__*/_react.default.createElement("span", {
      style: {
        background: selectedColor,
        ...colorbarOffset
      },
      className: `${colorpickerClassName}__colorbar`
    })), open && /*#__PURE__*/_react.default.createElement(_flyout.Flyout, (0, _extends2.default)({
      id: `${this._id}-flyout`,
      "data-tid": "ba-common-color-picker__flyout"
    }, flyoutExtraOptions, {
      "aria-hidden": open,
      placement: orientation // eslint-disable-next-line no-underscore-dangle
      ,
      triggerNode: this.buttonRef.current._node,
      domNodeToAttachTo: this._colorPickerNode,
      hideArrow: true,
      offset: DEFAULT_OFFSET,
      onClose: this._handleOpen,
      className: `${colorpickerClassName}__flyout`
    }), this.props.colors.map(this._displayColor)));
  }

}

exports.default = ColorPicker;
(0, _defineProperty2.default)(ColorPicker, "propTypes", {
  /** Colors to be selected */
  colors: _propTypes.default.array,

  /** Function that will get called on click of a color */
  onColorSelected: _propTypes.default.func,

  /** Selected color to show at the bottom of button */
  selectedColor: _propTypes.default.string,

  /** Flag to disable the color picker */
  disabled: _propTypes.default.bool,

  /** Tooltip when you hover on the color picker */
  title: _propTypes.default.string,

  /** Flyout.propTypes.placement, default bottomRightStart/bottomLeftStart */
  orientation: _flyout.Flyout.propTypes.placement,

  /** Custom class name(s) */
  className: _propTypes.default.string,

  /** Custom css styles */
  style: _propTypes.default.object,

  /** Extra options for the button to pass to Flyout */
  buttonExtraOptions: _propTypes.default.object,

  /** Extra options to pass to Flyout */
  flyoutExtraOptions: _propTypes.default.object,

  /** ColorBar offset */
  colorbarOffset: _propTypes.default.object
});
(0, _defineProperty2.default)(ColorPicker, "defaultProps", {
  disabled: false,
  title: _StringResource.default.get('title'),
  className: '',
  style: {},
  buttonExtraOptions: {},
  flyoutExtraOptions: {},
  colorbarOffset: {
    top: '12px',
    left: '1.25px'
  },
  orientation: _utils.Bidi.isMirroredUI() ? BOTTOM_RIGHT_START : BOTTOM_LEFT_START
});

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/text--color_32");

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ColorPicker_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ColorPicker_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ColorPicker_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ColorPicker_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ColorPicker_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _utils = __webpack_require__(5);

var _ColorPickerResources = _interopRequireDefault(__webpack_require__(256));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_ColorPickerResources.default);

exports.default = _default;

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

var amdi18n={"__root":{"title":"Selecting a color"},"__cs":{"title":"Výběr barvy"},"__da":{"title":"Vælg en farve"},"__de":{"title":"Farbe auswählen"},"__es":{"title":"Seleccionando un color"},"__fi":{"title":"Värin valinta"},"__fr":{"title":"Sélection d'une couleur"},"__hr":{"title":"Biranje boje"},"__hu":{"title":"Szín kiválasztása"},"__it":{"title":"Selezione di un colore"},"__ja":{"title":"カラーの選択"},"__kk":{"title":"Түсті таңдау"},"__ko":{"title":"색상 선택"},"__nb":{"title":"Velge en farge"},"__nl":{"title":"Een kleur selecteren"},"__no":{"title":"Velge en farge"},"__pl":{"title":"Wybieranie koloru"},"__pt":{"title":"Selecionando uma Cor"},"__pt-br":{"title":"Selecionando uma Cor"},"__ro":{"title":"Selectarea unei culori"},"__ru":{"title":"Выбор цвета"},"__sl":{"title":"Izbiranje barve"},"__sv":{"title":"Välj en färg"},"__th":{"title":"การเลือกสี"},"__tr":{"title":"Renk seçme"},"__zh":{"title":"选择颜色"},"__zh-cn":{"title":"选择颜色"},"__zh-hk":{"title":"選取顏色"},"__zh-mo":{"title":"選取顏色"},"__zh-sg":{"title":"选择颜色"},"__zh-tw":{"title":"選取顏色"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-colorpicker{position:relative}.ba-common-colorpicker__button.size-default{border:0px;padding:0px;min-height:0px}.ba-common-colorpicker__button svg{margin:0px !important}.ba-common-colorpicker__colorbar{color:#343334;width:14px;height:4px;position:absolute;-ms-high-contrast-adjust:none}.ba-common-colorpicker__colorbar:hover{cursor:pointer}.ba-common-colorpicker__flyout{padding:.3em;width:166px;flex-wrap:wrap;display:flex;justify-content:flex-start;-ms-high-contrast-adjust:none}.ba-common-colorpicker__cell{display:inline-block;width:16px;height:16px;margin:2px 1.6px;border:1px solid}.ba-common-colorpicker__cell:hover{cursor:pointer}.ba-common-colorpicker__cell{border-color:#eaeaea}", ""]);

// exports
exports.locals = {
	"colorpickerClassName": "\"ba-common-colorpicker\""
};

/***/ })

},[[250,0]]]);
});